var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var Label = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tjustify-content: flex-end;\n\twidth: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tuser-select: none;\n"], ["\n\tjustify-content: flex-end;\n\twidth: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tuser-select: none;\n"])));
var templateObject_1;
//# sourceMappingURL=Label.js.map